import {isMobile} from 'react-device-detect';

import {SIDE_NAV_LIGHT, NAV_TYPE_SIDE, NAV_TYPE_TOP, DIR_LTR, SIDE_NAV_DARK} from 'constants/ThemeConstant';
import {env} from './EnvironmentConfig'

let _isMobileApp=!!window.MOBILE_NEW_UI;
if(env.ENV !== 'PROD' && isMobile){
    _isMobileApp=true;
}

console.log("isMobileApp",_isMobileApp)
export const isMobileApp=_isMobileApp;

export const isNewUI=false
export const APP_NAME = 'Kehila';
export const API_BASE_URL = env.API_ENDPOINT_URL
export const ASSET_BASE_URL = env.ASSET_ENDPOINT_URL
export const PUBLIC_BASE_URL = env.PUBLIC_ENDPOINT_URL
export const WEB_BASE_URL = env.WEB_URL
export const CAMPAGNE_BASE_URL = env.CAMPAGNE_URL
export const ENV = env.ENV
export const APP_PREFIX_PATH = '/app';
export const AUTH_PREFIX_PATH = '/auth';
export const EDITOR_PREFIX_PATH = '/editor';
export const MOBILE_PREFIX_PATH = '/mobile';
export const REDIRECT_URL_KEY = 'redirect'

export const AUTHENTICATED_ENTRY = isMobileApp?`${MOBILE_PREFIX_PATH}/dashboard`:`${APP_PREFIX_PATH}/dashboards/resume`
export const UNAUTHENTICATED_ENTRY = '/login'

export const THEME_CONFIG = {
    navCollapsed: localStorage.getItem("navCollapse") === "true",
    //sideNavTheme: localStorage.getItem("navStyle") ? localStorage.getItem("navStyle") : SIDE_NAV_LIGHT,
    sideNavTheme: SIDE_NAV_DARK,
    locale: 'fr',
    navType: localStorage.getItem("navType") ? localStorage.getItem("navType") : NAV_TYPE_SIDE,
    topNavColor: localStorage.getItem("topNavColor") ? localStorage.getItem("topNavColor") : '#F4F6F6',
    headerNavColor: localStorage.getItem("headerNavColor") ? localStorage.getItem("headerNavColor") : '',
    mobileNav: false,
    currentTheme: localStorage.getItem("theme") ? localStorage.getItem("theme") : 'light',
    direction: DIR_LTR,
    blankLayout: false
};


export const MOBCOLORS = {
    blue: {
        color: "#2B70A9",
        backgroundColor: "#CBDEED", // dérivé
    },
    purple: {
        color: "#CB6CE6",
        backgroundColor: "#F2D4F8", // dérivé
    },
    red: {
        color: "#FF3131",
        backgroundColor: "#FFD6D6", // dérivé
    },
    orange: {
        color: "#FF914D",
        backgroundColor: "#FFE0CC", // dérivé
    },
    green: {
        color: "#00BF63",
        backgroundColor: "#C9F5DC", // dérivé
    },

    cyan: {
        color: "#17A2B8",
        backgroundColor: "#D1EEF3",
    },
    teal: {
        color: "#20C997",
        backgroundColor: "#CFF4EA",
    },
    amber: {
        color: "#FFC107",
        backgroundColor: "#FFF3CD",
    },
    pink: {
        color: "#EC4899",
        backgroundColor: "#FBD5E7",
    },
    indigo: {
        color: "#6366F1",
        backgroundColor: "#E0E2FB",
    },
    gray: {
        color: "#6C757D",
        backgroundColor: "#E2E3E5",
    },
}
